import cn from 'classnames';
import { FC } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { Badge, Flex } from 'antd';
import { bem } from '../../utils/bem';
import type { MenuItemProps } from './MenuItemProps';
import './MenuItem.scss';

const b = bem('menu-item');

export const MenuItem: FC<MenuItemProps> = ({ menuKey, to, label, badges, className }) => (
  <Flex className={cn(className, b())} gap="small" align="center">
    <NavLink to={to} style={{ flexGrow: 1 }}>
      {label}
    </NavLink>
    {Object.keys(badges).includes(menuKey) && <Badge count={badges[menuKey as keyof typeof badges]} size="small" />}
  </Flex>
);
